<script setup lang="ts">
import { PhCaretRight } from "@phosphor-icons/vue";
</script>

<template>
  <section
    id="productInfoSection"
    class="product-info-section"
    aria-label="商品信息"
    hidden
  >
    <button
      id="productInfoDetailButton"
      class="product-info-entry"
      type="button"
      aria-label="查看完整商品信息"
      disabled
    >
      <span class="product-info-heading">
        <span id="productInfoTitle" class="product-info-label">商品信息</span>
        <PhCaretRight class="product-info-chevron" :size="16" weight="bold" aria-hidden="true" />
      </span>
      <span id="productInfoProductTitle" class="product-info-product-title">正在读取商品标题</span>
      <span id="productInfoSummary" class="product-info-summary">正在整理商品信息</span>
      <span id="productInfoNote" class="product-info-note" hidden></span>
    </button>
  </section>
</template>
